// import React, { createContext, useContext, useState, useEffect } from 'react';  

// // Create Token Context  
// const TokenContext = createContext();  

// export const TokenProvider = ({ children }) => {  
//   const [token, setToken] = useState(() => localStorage.getItem("token"));  

//   useEffect(() => {  
//     // Synchronize state with localStorage  
//     if (token) {  
//       localStorage.setItem("token", token);  
//     } else {  
//       localStorage.removeItem("token");  
//     }  
//   }, [token]);  

//   return (  
//     <TokenContext.Provider value={{ token, setToken }}>  
//       {children}  
//     </TokenContext.Provider>  
//   );  
// };  

// // Custom hook for accessing TokenContext  
// export const useToken = () => useContext(TokenContext);

import React, { createContext, useContext, useState, useEffect } from 'react';  

// Create Token Context  
const TokenContext = createContext();  

export const TokenProvider = ({ children }) => {  
  const [token, setTokenState] = useState(() => localStorage.getItem("token"));  

  const setToken = (newToken) => {
    setTokenState(newToken);
  };

  useEffect(() => {  
    if (token) {  
      localStorage.setItem("token", token);  
    } else {  
      localStorage.removeItem("token");  
    }  
  }, [token]);  

  return (  
    <TokenContext.Provider value={{ token, setToken }}>  
      {children}  
    </TokenContext.Provider>  
  );  
};  

// Custom hook for accessing TokenContext  
export const useToken = () => useContext(TokenContext);